import { connect } from 'react-redux';
import VersionsList from './List';
import { getVersions, activateVersion, createVersion } from '../actions';
import { enableActivateVersion } from 'app/dux/profile/selectors';

const mapStateToProps = state => ( {
    enableActivateVersion: enableActivateVersion( state )
} );

const mapDispatchToProps = {
    getVersions,
    createVersion,
    activateVersion
};

export default connect( mapStateToProps, mapDispatchToProps )( VersionsList );
